mutation AccountEnrichmentRespond($input: AccountEnrichmentRespondInput!) {
    accountEnrichmentRespond(input: $input) {
        account {
            id
        }
    }
}
